import { render } from "./IconLastPage.vue?vue&type=template&id=8c4b258a"
import script from "./IconLastPage.vue?vue&type=script&lang=js"
export * from "./IconLastPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\suph-annuaire-plugin\\suph-card-pro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__